export enum InputType {
  TEXT = 'text',
  PASSWORD = 'password',
  SELECT = 'select',
  // Mapping for Control + Drop Select Item
  // e.g. Jira, Azure Boards
  CONTROL_MAPPING = 'control_mapping',
  // Mapping for Control + Input Text
  // e.g. Confluence Url Mapping
  MANUAL_CONTROL_MAPPING = 'manual_control_mapping',
  // Mapping for Control + 2 Select Items + Checkbox
  // e.g. Confluence Label Mappings
  STACKED_MAPPING = 'stacked_mapping',
  // Mapping for Name, Parent Select Item + Children Select Item
  // e.g Jira Workflow
  PROJECT_MAPPING = 'project_mapping',
  // Mapping for Parent Select Item + 3 Children Select Item
  // e.g. ServiceNow Workflow Advaned Mappings
  ADVANCE_MAPPING = 'advance_mapping',
  JSON = 'json',
  LIST_CONFIG = 'list_config',
}
